import { Typography, Button, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HomeWidgetTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom['gray-10'],
  fontSize: '14px',
  marginBottom: '16px',
}));

export const HomeWidgetHeaderGrid = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 16,
});

export const HomeWidgetButton = styled(Button)({
  borderRadius: '8px',
  border: '2px solid #2196F3',
  background: 'transparent',
  color: '#2196F3',
  fontWeight: 500,
  fontSize: '16px',
  padding: '1px 24px',
  textTransform: 'none',
  boxShadow: 'none',
  minWidth: 'unset',
  transition: 'border-color 0.2s, background 0.2s',
  '&:hover': {
    background: 'rgba(33,150,243,0.04)',
    border: '2px solid #1976D2',
    color: '#1976D2',
    boxShadow: 'none',
  },
});
